/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meta V6|V7 API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  DataStatCommonCategoriesResponse,
  DataStatDetailSelectorResponse,
  DataStatFavoritePatchRequest,
  DataStatSelectorResponse,
  GetV7DatasStatCommonCategoriesParams,
  GetV7DatasStatDetailParams,
  GetV7DatasStatParams,
  PostV7DatasStatFavoriteParams,
  SuccessResponse,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Stat 목록 조회
 */
export const getV7DatasStat = (
  params?: MaybeRef<GetV7DatasStatParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<DataStatSelectorResponse>(
    { url: `/api/v7/datas/stat`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7DatasStatQueryKey = (params?: MaybeRef<GetV7DatasStatParams>) => {
  return ['api', 'v7', 'datas', 'stat', ...(params ? [params] : [])] as const;
};

export const getGetV7DatasStatQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7DatasStat>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV7DatasStatParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7DatasStat>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7DatasStatQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7DatasStat>>> = ({ signal }) =>
    getV7DatasStat(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7DatasStat>>,
    TError,
    TData
  >;
};

export type GetV7DatasStatQueryResult = NonNullable<Awaited<ReturnType<typeof getV7DatasStat>>>;
export type GetV7DatasStatQueryError = ErrorType<unknown>;

/**
 * @summary Stat 목록 조회
 */

export function useGetV7DatasStat<
  TData = Awaited<ReturnType<typeof getV7DatasStat>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV7DatasStatParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7DatasStat>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7DatasStatQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Stat 카테고리 목록 조회(common 유형 포함)
 */
export const getV7DatasStatCommonCategories = (
  params?: MaybeRef<GetV7DatasStatCommonCategoriesParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<DataStatCommonCategoriesResponse>(
    { url: `/api/v7/datas/stat/common-categories`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7DatasStatCommonCategoriesQueryKey = (
  params?: MaybeRef<GetV7DatasStatCommonCategoriesParams>,
) => {
  return ['api', 'v7', 'datas', 'stat', 'common-categories', ...(params ? [params] : [])] as const;
};

export const getGetV7DatasStatCommonCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7DatasStatCommonCategories>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV7DatasStatCommonCategoriesParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7DatasStatCommonCategories>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7DatasStatCommonCategoriesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7DatasStatCommonCategories>>> = ({
    signal,
  }) => getV7DatasStatCommonCategories(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7DatasStatCommonCategories>>,
    TError,
    TData
  >;
};

export type GetV7DatasStatCommonCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7DatasStatCommonCategories>>
>;
export type GetV7DatasStatCommonCategoriesQueryError = ErrorType<unknown>;

/**
 * @summary Stat 카테고리 목록 조회(common 유형 포함)
 */

export function useGetV7DatasStatCommonCategories<
  TData = Awaited<ReturnType<typeof getV7DatasStatCommonCategories>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV7DatasStatCommonCategoriesParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7DatasStatCommonCategories>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7DatasStatCommonCategoriesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Stat 상세 목록 조회
 */
export const getV7DatasStatDetail = (
  params: MaybeRef<GetV7DatasStatDetailParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<DataStatDetailSelectorResponse>(
    { url: `/api/v7/datas/stat/detail`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7DatasStatDetailQueryKey = (params?: MaybeRef<GetV7DatasStatDetailParams>) => {
  return ['api', 'v7', 'datas', 'stat', 'detail', ...(params ? [params] : [])] as const;
};

export const getGetV7DatasStatDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7DatasStatDetail>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7DatasStatDetailParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7DatasStatDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7DatasStatDetailQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7DatasStatDetail>>> = ({ signal }) =>
    getV7DatasStatDetail(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7DatasStatDetail>>,
    TError,
    TData
  >;
};

export type GetV7DatasStatDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7DatasStatDetail>>
>;
export type GetV7DatasStatDetailQueryError = ErrorType<unknown>;

/**
 * @summary Stat 상세 목록 조회
 */

export function useGetV7DatasStatDetail<
  TData = Awaited<ReturnType<typeof getV7DatasStatDetail>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7DatasStatDetailParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7DatasStatDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7DatasStatDetailQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Stat 사용자 즐겨찾기 정보 등록(수정)
 */
export const postV7DatasStatFavorite = (
  dataStatFavoritePatchRequest: MaybeRef<DataStatFavoritePatchRequest>,
  params: MaybeRef<PostV7DatasStatFavoriteParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  dataStatFavoritePatchRequest = unref(dataStatFavoritePatchRequest);
  params = unref(params);

  return customAxiosInstance<SuccessResponse>(
    {
      url: `/api/v7/datas/stat/favorite`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: dataStatFavoritePatchRequest,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV7DatasStatFavoriteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7DatasStatFavorite>>,
    TError,
    { data: BodyType<DataStatFavoritePatchRequest>; params: PostV7DatasStatFavoriteParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7DatasStatFavorite>>,
  TError,
  { data: BodyType<DataStatFavoritePatchRequest>; params: PostV7DatasStatFavoriteParams },
  TContext
> => {
  const mutationKey = ['postV7DatasStatFavorite'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7DatasStatFavorite>>,
    { data: BodyType<DataStatFavoritePatchRequest>; params: PostV7DatasStatFavoriteParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV7DatasStatFavorite(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7DatasStatFavoriteMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7DatasStatFavorite>>
>;
export type PostV7DatasStatFavoriteMutationBody = BodyType<DataStatFavoritePatchRequest>;
export type PostV7DatasStatFavoriteMutationError = ErrorType<unknown>;

/**
 * @summary Stat 사용자 즐겨찾기 정보 등록(수정)
 */
export const usePostV7DatasStatFavorite = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7DatasStatFavorite>>,
      TError,
      { data: BodyType<DataStatFavoritePatchRequest>; params: PostV7DatasStatFavoriteParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7DatasStatFavorite>>,
  TError,
  { data: BodyType<DataStatFavoritePatchRequest>; params: PostV7DatasStatFavoriteParams },
  TContext
> => {
  const mutationOptions = getPostV7DatasStatFavoriteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
